import { useState } from 'react';

import { getContext } from '@/context';
import useMount from './useMount';

const useAuth = () => {
  const [isAuthorized, setIsAuthorized] = useState(
    getContext().general.auth.getState().isAuthorized
  );

  useMount(() => {
    const unSubscribe = getContext().general.auth.subscribe((state) => {
      setIsAuthorized(state.isAuthorized);
    });

    return () => {
      unSubscribe?.();
    };
  });

  return { isAuthorized };
};

export { useAuth };
export default useAuth;
